/**
 * O QUE O DETALHE DA MÁQUINA NA MESA PEDE, E COM QUE LICENÇA.
 *
 * Achado dos robôs no QAS (20/10/2026, rodada 2): operador, almoxarifado e
 * compras abriam a máquina em /equipamentos e o painel disparava
 * `/equipamentos/:id/prontuario` (prontuario.ler) e `/operacao/cadastros`
 * (operacao.ler) — 403, toast "Não foi feito… sem permissão" e "Você não tem
 * acesso" dentro do painel, numa tela que o menu do próprio perfil oferece. A
 * mesma família da ficha do operador no celular (36a8529) e da tela de pessoas
 * (`src/modulos/pessoas/leitura.ts`).
 *
 * A regra: cada consulta do painel só sai com a licença da rota que ela chama
 * (o `config.exige` do backend). O que o perfil não lê não aparece — o painel
 * mostra a ficha da máquina, a alocação e a situação que ele já tem pela
 * lista —, e não vira estado de erro. O teste `leitura-do-detalhe.test.ts`
 * confere cada licença daqui contra a rota do servidor.
 */
export const CONSULTAS_DO_DETALHE = {
  /** O uso, o consumo efetivo, custo e peças, os históricos e a aba Histórico. */
  prontuario: { rota: '/equipamentos/:id/prontuario', licenca: 'prontuario.ler' },
  /** As causas de parada, que o formulário de situação pede em Parada e Em manutenção. */
  causas: { rota: '/operacao/cadastros', licenca: 'operacao.ler' },
} as const;

export type ConsultaDoDetalhe = keyof typeof CONSULTAS_DO_DETALHE;

/** O que o perfil lê no detalhe. `null` é a sessão em trânsito: nada sai até ela chegar. */
export function oQueODetalheLe(permissoes: readonly string[] | null): Readonly<Record<ConsultaDoDetalhe, boolean>> {
  const tem = new Set(permissoes ?? []);
  return {
    prontuario: tem.has(CONSULTAS_DO_DETALHE.prontuario.licenca),
    causas: tem.has(CONSULTAS_DO_DETALHE.causas.licenca),
  };
}

/**
 * As abas do painel que têm o que mostrar ao perfil. Sem o prontuário, a aba
 * Alocação só existe para quem aloca e a Situação para quem registra
 * situação — uma aba vazia é a "tabela em branco" que o manual proíbe (p.34);
 * a obra, o cliente e o status já estão no cabeçalho do painel.
 */
export function abasDoDetalhe(permissoes: readonly string[] | null): Readonly<Record<'ficha' | 'alocacao' | 'situacao' | 'historico', boolean>> {
  const tem = new Set(permissoes ?? []);
  const { prontuario } = oQueODetalheLe(permissoes);
  return {
    ficha: true,
    alocacao: prontuario || tem.has('alocacao.gerir'),
    situacao: prontuario || tem.has('situacao.registrar'),
    historico: prontuario,
  };
}
